import { call, put, takeLatest } from 'redux-saga/effects'
import {
    GET_USERS_REQUEST,
    DELETE_USER_REQUEST,
    CHANGE_USER_STATUS_REQUEST,
    ADD_USER_REQUEST,
    EDIT_USER_REQUEST,
    GET_ALL_USERS_REQUEST,
    GET_DENTIST_INFO_REQUEST,
    GENERATE_RESET_PASSWORD_LINK_REQUEST,
} from './constants';
import {
    getUsersSuccess,
    getUsersFailure,
    deleteUserSuccess,
    deleteUserFailure,
    changeUserStatusSuccess,
    changeUserStatusFailure,
    addUserFailureAction,
    addUserSuccessAction,
    editUserSuccessAction,
    editUserFailureAction,
    getAllUsersSuccess,
    getAllUsersFailure,
    getDentistInfoSuccessAction,
    getDentistInfoFailureAction,
    generateResetPasswordLinkSuccess,
    generateResetPasswordLinkFailure,
} from "./actions";
import { getUsersForChatSuccess } from '../../../Chat/actions';
import remote from '../../../../services/remote'
import SentryManager from "../../../../monitoring/Sentry";

function* getDentists (action) {
    try {
        const response = yield call(remote, {
            route: '/dentists/get-dentists',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(getUsersSuccess(response.data));
            yield put(getUsersForChatSuccess(response.data));
        } else {
            yield put(getUsersFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* getAllDentists (action) {
    try {
        const response = yield call(remote, {
            route: '/dentists/get-dentists',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(getAllUsersSuccess(response.data));
        } else {
            yield put(getAllUsersFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* deleteDentist (action) {
    try {
        const response = yield call(remote, {
            route: '/dentists/delete-dentist',
            method: 'delete',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(deleteUserSuccess(response.data));
        } else {
            yield put(deleteUserFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* changeDentistStatus (action) {
    try {
        const response = yield call(remote, {
            route: '/dentists/change-dentist-status',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(changeUserStatusSuccess(response.data));
        } else {
            yield put(changeUserStatusFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* addUser (action) {
    try {
        const response = yield call(remote, {
            route: '/admin/dentists/add-dentist',
            method: 'post',
            body: JSON.stringify(action.data.user)
        });
        if (response.success) {
            yield put(addUserSuccessAction(response.data));
        } else {
            yield put(addUserFailureAction(response));
        }
    } catch (e) {
        console.log(e);
        SentryManager.captureException(e);
    }
}

function* editUser (action) {
    try {
        const response = yield call(remote, {
            route: '/admin/dentists/edit-dentist',
            method: 'put',
            body: JSON.stringify(action.data.user)
        });
        if (response.success) {
            yield put(editUserSuccessAction(response.data));
        } else {
            yield put(editUserFailureAction(response));
        }
    } catch (e) {
        console.log(e);
        SentryManager.captureException(e);
    }
}

function* getDentistInfo (action) {
    try {
        const response = yield call(remote, {
            route: `/admin/dentists/get-dentist/${action.data}`,
            method: 'get',
        });
        if (response.success) {
            yield put(getDentistInfoSuccessAction(response.data));
        } else {
            yield put(getDentistInfoFailureAction(response.data));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* generateRestPasswordLink (action) {
    try {
        const response = yield call(remote, {
            route: `/admin/dentists/generate-reset-password-link`,
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(generateResetPasswordLinkSuccess(response.data));
        } else {
            yield put(generateResetPasswordLinkFailure(response.data));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

export default function* watchDentists() {
    yield takeLatest(GET_USERS_REQUEST , getDentists);
    yield takeLatest(DELETE_USER_REQUEST , deleteDentist);
    yield takeLatest(CHANGE_USER_STATUS_REQUEST , changeDentistStatus);
    yield takeLatest(ADD_USER_REQUEST, addUser);
    yield takeLatest(EDIT_USER_REQUEST, editUser);
    yield takeLatest(GET_ALL_USERS_REQUEST, getAllDentists);
    yield takeLatest(GET_DENTIST_INFO_REQUEST, getDentistInfo);
    yield takeLatest(GENERATE_RESET_PASSWORD_LINK_REQUEST, generateRestPasswordLink);
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/Dentists/saga.js